// Import TailwindCSS
import '../../src/css/main.css';

// Import Alpine.js voor interactieve componenten
import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

// DOM Ready
document.addEventListener('DOMContentLoaded', function() {
  // Smooth scroll voor anchor links (exclude WordPress admin bar)
  document.querySelectorAll('a[href^="#"]:not(#wpadminbar a):not(.ab-item)').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      
      // Skip special anchors en WordPress admin links
      if (href === '#' || href === '#0' || href.startsWith('#wp')) {
        return;
      }
      
      // Only smooth scroll if target exists
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Sticky header met shadow bij scroll
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        header.classList.add('shadow-md');
      } else {
        header.classList.remove('shadow-md');
      }
    });
  }
});

// Contact form handling (als je een custom contact form hebt)
const contactForm = document.getElementById('contact-form');
if (contactForm) {
  contactForm.addEventListener('submit', async function(e) {
    e.preventDefault();
    
    const formData = new FormData(this);
    const submitButton = this.querySelector('button[type="submit"]');
    const originalButtonText = submitButton.textContent;
    
    submitButton.textContent = 'Verzenden...';
    submitButton.disabled = true;
    
    try {
      const response = await fetch(yogacentrumData.ajaxUrl, {
        method: 'POST',
        body: formData
      });
      
      const data = await response.json();
      
      if (data.success) {
        this.reset();
        showNotification('Bedankt voor je bericht! We nemen zo snel mogelijk contact met je op.', 'success');
      } else {
        showNotification('Er is iets misgegaan. Probeer het later opnieuw.', 'error');
      }
    } catch (error) {
      console.error('Error:', error);
      showNotification('Er is iets misgegaan. Probeer het later opnieuw.', 'error');
    } finally {
      submitButton.textContent = originalButtonText;
      submitButton.disabled = false;
    }
  });
}

// Notification helper
function showNotification(message, type = 'info') {
  const notification = document.createElement('div');
  notification.className = `fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 ${
    type === 'success' ? 'bg-green-500' : 
    type === 'error' ? 'bg-red-500' : 
    'bg-blue-500'
  } text-white`;
  notification.textContent = message;
  
  document.body.appendChild(notification);
  
  setTimeout(() => {
    notification.classList.add('fade-out');
    setTimeout(() => notification.remove(), 300);
  }, 5000);
}

console.log('Yogacentrum Genk theme loaded');
